<template>
    <main-section>
        <template v-if="!isInitiated">
            <v-fade-transition>
                <v-overlay color="white" v-show="loading">
                    <v-progress-circular size="100" width="5" color="primary" indeterminate />
                </v-overlay>
            </v-fade-transition>
        </template>
        <template v-if="!!lecture">
            <template v-if="!lecture?.isActive">
                <view-stop />
            </template>
            <template v-else-if="!isAccessible">
                <view-code />
            </template>
            <template v-else>
                <v-row>
                    <v-col cols="12" lg="9">
                        <view-info>
                            <view-video />
                        </view-info>
                    </v-col>
                    <v-col cols="12" lg="3">
                        <view-chat />
                    </v-col>
                    <v-col cols="12" v-if="isUserCompany">
                        <view-meta />
                    </v-col>
                </v-row>
            </template>
        </template>
        <template v-else>
            <view-stop />
        </template>
    </main-section>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

import MainSection from "@/components/client/main/main-section.vue";
import ViewCode from "./view-code.vue";
import ViewChat from "./view-chat.vue";
import ViewInfo from "./view-info.vue";
import ViewMeta from "./view-meta.vue";
import ViewStop from "./view-stop.vue";
import ViewVideo from "./view-video.vue";

export default {
    components: {
        MainSection,
        ViewCode,
        ViewChat,
        ViewInfo,
        ViewMeta,
        ViewStop,
        ViewVideo,
    },
    data: () => ({
        loading: false,
    }),
    computed: {
        ...mapState("lecture", ["lecture", "_lecture", "isAccessible"]),
        ...mapGetters("lecture", ["isUserCompany"]),
        isInitiated() {
            return this.lecture?._id == this._lecture;
        },
    },
    methods: {
        ...mapMutations("lecture", ["reset"]),
        ...mapActions("lecture", ["getLecture"]),

        async init() {
            if (this.loading) return;
            else this.loading = true;

            try {
                await this.getLecture();
            } finally {
                this.loading = false;
            }
        },
    },
    mounted() {
        if (this._lecture) this.init();
    },
    beforeDestroy() {
        this.reset();
    },
    watch: {
        _lecture() {
            this.init();
        },
    },
};
</script>

<style>
</style>